import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
/* eslint-disable no-param-reassign */
import axios from 'axios';
import router from '@/router';
import store from '@/store';
const service = axios.create({
  timeout: 30 * 1000,
  withCredentials: true
});
export const httpGet = (url, data, config) => service({
  url,
  params: data,
  method: 'get',
  ...config
});
export const httpPost = (url, data, config) => service({
  url,
  data,
  method: 'post',
  ...config
});

// 请求拦截器
service.interceptors.request.use(config => config, error => Promise.reject(error));

/* 响应拦截器 */
service.interceptors.response.use(response => {
  const {
    data
  } = response;
  // 20000 未激活  20001 用户未登录   20002 登录信息过期  20003 邮箱或验证码不为空  20004 验证码有误
  const no_active_code = 20000;
  const no_loggoed_code = 20001;
  const login_expired_code = 20002;
  if (data.code === no_loggoed_code || data.code === login_expired_code) {
    store.commit('user/setHasLogin', false);
    store.commit('user/setUserInfo', {});
    // message.error(data.msg);
    // router.push({ path: '/homepage' });
  } else if (data.code === no_active_code) {
    if (store.state.user.hasLogin) {
      store.commit('user/setUserCode', false);
    } else {
      store.commit('user/setUserCode', true);
    }
    _message.error(data.msg);
  } else if (data.code !== 1 && data.code !== no_active_code && data.code !== no_loggoed_code && data.code !== 0 && data.code !== 20009) {
    // 文本翻译返回的data可能为zh
    if (data.msg) {
      _message.error(data.msg);
    }
  } else {}
  return data;
}, error =>
// message.error(error.message);
Promise.reject(error));